import { IGroupInfo } from "@home-health-notify/domain";
import { Box, Typography } from "@mui/material";
import { convertOrdinalWordToNumber, useTranslation } from "hhn-commons";
import React from "react";

const Lupa = ({ groupInfo }: { groupInfo: IGroupInfo }) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "groupChatInfo" });
  const lupa = groupInfo.lupa;
  const actualVisitCount = groupInfo.actualVisitCount;
  if (!lupa) return null;
  return (
    <Box>
      {Object.entries(lupa).map(([key, value]) => {
        const [ordinal] = key.split("Session");
        const formattedKey = ordinal
          ? `${convertOrdinalWordToNumber(ordinal.trim())} 30 days`
          : key;
        const actualVisitCountValue =
          actualVisitCount && actualVisitCount[key] ? actualVisitCount[key] : 0;
        const isMet =
          actualVisitCountValue !== 0 && actualVisitCountValue >= value;
        return (
          <Box key={key}>
            <Typography component="span">{formattedKey}- </Typography>
            <Typography component="span">
              {actualVisitCountValue} / {value}{" "}
              <Typography component="span">
                {isMet ? (
                  <Typography component="span" color="success">
                    ({tNs("careTimeline.lupaCriteria.met")})
                  </Typography>
                ) : (
                  <Typography component="span" color="error">
                    ({tNs("careTimeline.lupaCriteria.notMet")})
                  </Typography>
                )}
              </Typography>
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default Lupa;
